import styled from '@emotion/styled'
import { css } from '@emotion/react'

const wrapperStyles = ({ theme }) => css`
  label: wrapper;

  display: grid;
  place-items: center;
  width: 100%;
  min-height: 450px;
  background: ${theme.colors.n100};
  border-radius: 10px;

  ${theme.media.mega} {
    border-radius: 0;
  }
`

export const Wrapper = styled('div')(wrapperStyles)
